import initialState from './initialState'

// Types
const SET_PAGE = 'routing/SET_PAGE'

// Action Creators
export const setPage = page => ({
  type: SET_PAGE,
  payload: page
})

// Reducer
const reducer = (state = initialState, { type: actionType, payload }) => {
  switch (actionType) {
  case SET_PAGE:
    return {
      ...state,
      page: payload
    }
  default:
    return state
  }
}

export default reducer
